<template>
  <div class="w-full height-100">
    <div class="seth-set bg-primary">
      <div class="absolute top-0 py-10 w-full px-6 flex">
        <div class="">
          <p
            @click="handleBack"
            class="gap-2 cursor-pointer fsize14 mb-1 text-white flex items-center font-medium"
          >
            <feather-icon
              class="flex"
              icon="ArrowLeftIcon"
              svgClasses="w-6 h-6"
            />
            Go Back
          </p>
          <h2 class="text-white pt-1 text-2xl capitalize font-semibold">
            Error Logs
          </h2>
        </div>
      </div>
    </div>

    <div class="bg-white px-6 pt-6 pb-32 menucontrol-scroll fixed-top">
      <div class="mb-2 flex gap-2 items-center">
        <div class="w-1/2">
          <div class="relative">
            <el-input
              placeholder="search"
              v-model="search"
              maxlength="50"
              class="rounded-none"
            ></el-input>
            <div class="absolute top-0 right-0 mt-2 mr-2">
              <feather-icon icon="SearchIcon" class="" />
            </div>
          </div>
        </div>
        <div class="w-1/2 flex justify-between">
          <el-date-picker
            v-model="datefilter"
            type="date"
            placeholder="Pick a day"
          >
          </el-date-picker>
          <div class="right">
            <el-tooltip
              class="item"
              effect="dark"
              content="Only last 30 days records available"
              placement="left-end"
            >
              <el-button
                class="h-8 w-8 flex justify-center items-center btncss"
              >
                <feather-icon
                  icon="InfoIcon"
                  class="cursor-pointer h-4 w-4 textbtn"
                />
              </el-button>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="">
        <el-table
          :data="errorlog[0].paginatedresult"
          border
          style="width: 100%"
          class="table-responsive table-flush mt-6 cust-overflow-x-primary-color"
          header-row-class-name="thead-light table-th-colorpd"
          ><el-table-column
            :index="indexmethod"
            type="index"
            label="Sr.no"
            width="80"
          ></el-table-column>
          <!-- <el-table-column prop="city" label="Type" min-width="100px">
            <template v-slot="{row}">  <P class="text-gray">{{ row.type }}</P></template>
          </el-table-column> -->
          <el-table-column prop="logid" label="ID" min-width="50px">
            <template v-slot="{ row }">
              <P class="text-gray">{{ row.logid }}</P></template
            >
          </el-table-column>
          <el-table-column prop="user" label="User" min-width="200px">
            <template v-slot="{ row }">
              <P class="text-gray"
                >{{ row.user.firstName }} {{ row.user.lastName }}
              </P></template
            >
          </el-table-column>
          <el-table-column
            prop="ipAddress"
            label="Ip Address"
            min-width="200px"
          >
            <template v-slot="{ row }">
              <P class="text-gray">{{ row.ipAddress }}</P></template
            >
          </el-table-column>
          <el-table-column
            prop="operatingSystem"
            label="Operating System"
            min-width="200px"
          >
            <template v-slot="{ row }">
              <P class="text-gray">{{ row.operatingSystem }}</P></template
            >
          </el-table-column>
          <el-table-column prop="Browser" label="Browser" min-width="200px">
            <template v-slot="{ row }">
              <P class="text-gray">{{ row.browser }}</P></template
            >
          </el-table-column>
          <el-table-column prop="name" label="Response Code" min-width="200px">
            <template v-slot="{ row }">
              <P class="text-gray">{{ row.statuscode }}</P></template
            >
          </el-table-column>
          <el-table-column prop="name" label="Message" min-width="200px">
            <template v-slot="{ row }">
              <P class="text-gray">{{ row.error }}</P></template
            >
          </el-table-column>

          <el-table-column prop="date" label="Date" min-width="200px">
            <template v-slot="{ row }">
              <P class="text-gray">{{
                row.updatedAt | moment("dddd, MMMM Do YYYY")
              }}</P></template
            >
          </el-table-column>
          <el-table-column prop="zip" label="Time" min-width="200px">
            <template v-slot="{ row }">
              <P class="text-gray">{{
                row.updatedAt | moment("h:mm:ss a")
              }}</P></template
            >
          </el-table-column>
        </el-table>
        <!-- | moment("dddd, MMMM Do YYYY, h:mm:ss a") -->
        <div
          class="w-full flex justify-end mt-6"
          v-if="errorlog[0].totalcount.length > 0"
        >
          <el-pagination
            pills
            :total="Number(errorlog[0].totalcount[0].count)"
            layout="prev,pager,next"
            background
            :current-page="currentPage"
            @current-change="handlePageChange"
            size="sm"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import moment from "moment";
export default {
  data() {
    return {
      currentPage: 1,
      search: "",
      offset: null,
      datefilter: "",
      drawer: false,
      direction: "rtl",
      subcategoryoptions: [
        {
          value: "HTML",
          label: "HTML",
        },
        {
          value: "CSS",
          label: "CSS",
        },
        {
          value: "JavaScript",
          label: "JavaScript",
        },
      ],
      tableData: [
        {
          date: "20 Dec 2023",
          name: "Payment Required",
          state: "PR-1",
          city: "402",
          address: "No. 189, Grove St, Los Angeles",
          zip: "7:09PM",
        },
        {
          date: "11 Feb 2023",
          name: "Internal Server Error",
          state: "PR-1",
          city: "500",
          address: "No. 189, Grove St, Los Angeles",
          zip: "4:00AM",
        },
        {
          date: "20 Jan 2023",
          name: "Internal Server Error",
          state: "PR-1",
          city: "500",
          address: "No. 189, Grove St, Los Angeles",
          zip: "2:00PM",
        },
        {
          date: "11 June 2023",
          name: "Bad Gateway",
          state: "PR-1",
          city: "502",
          address: "No. 189, Grove St, Los Angeles",
          zip: "1:10PM",
        },
        {
          date: "20 March 2023",
          name: "Bad Gateway",
          state: "PR-1",
          city: "502",
          address: "No. 189, Grove St, Los Angeles",
          zip: "12:00AM",
        },
      ],
    };
  },
  watch: {
    datefilter(val) {
      this.datefilter = val;
      this.GetErrorLog();
    },

    search(val) {
      this.GetErrorLog();
    },
  },
  methods: {
    async handlePageChange(value) {
      this.currentPage = value;

      this.offset =
        this.currentPage > 1 ? (this.currentPage - 1) * 10 : this.currentPage;
      this.GetErrorLog();
    },
    indexmethod(index) {
      if (this.currentPage > 1) {
        let value = (this.currentPage - 1) * 10;
        return index + value + 1;
      } else {
        return index + 1;
      }
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },

    async GetErrorLog() {
      try {
        const payload = {};
        if (this.offset != null) {
          Object.assign(payload, { offset: this.offset });
        }
        if (this.search !== "") {
          Object.assign(payload, { search: this.search });
        }

        if (this.datefilter != "") {
          Object.assign(payload, { datefilter: this.datefilter });
        }
        let data = await this.$store.dispatch("logs/ErrorLOG", payload);
      } catch (err) {}
    },
  },
  computed: {
    ...mapState("logs", ["errorlog"]),
    getDate(createdAt) {
      const data = new Date(createdAt);
      return moment(data).format("MMMM Do YYYY");
    },
  },

  mounted() {
    this.GetErrorLog();
  },
};
</script>
